import { queryOptions } from "@tanstack/react-query";
import { getFavoriteArticles, getFavoriteWorkshops, getUserProfileData, getSubscriptionCourse } from "./api";
import type { CourseKey } from "./api.types";

export const getFavoriteArticlesOptions = queryOptions({
	queryKey: ["favorite-articles"],
	queryFn: () => getFavoriteArticles(),
});

export const getFavoriteWorkshopsOptions = queryOptions({
	queryKey: ["favorite-workshops"],
	queryFn: () => getFavoriteWorkshops(),
});

export const getProfileOptions = queryOptions({
	queryKey: ["profile"],
	queryFn: () => getUserProfileData(),
	staleTime: 1000 * 60 * 60 * 24, // 24 hours
	// przy okazji zrefactorowałbym dziwną logikę miedzy WorkshopContentAuth oraz WorkshopStudy !!! (o co tam chodzi?)
});

// Inner helper exists so TypeScript picks the correct `queryOptions` overload
// (UnusedSkipTokenOptions, which excludes SkipToken from queryFn) via call-site
// resolution and preserves the DataTag on `queryKey` for `getQueryData` inference.
// `ReturnType<typeof queryOptions<...>>` on the export would pick the last overload
// (UndefinedInitialDataOptions) and break assignment to `useSuspenseQuery`.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const subscriptionCourseOptionsImpl = (courseKey: CourseKey) =>
	queryOptions({
		queryKey: ["subscriptionCourse", courseKey] as const,
		queryFn: () => getSubscriptionCourse(courseKey),
	});

export const getSubscriptionCourseOptions = (
	courseKey: CourseKey,
): ReturnType<typeof subscriptionCourseOptionsImpl> =>
	subscriptionCourseOptionsImpl(courseKey);
